import React from 'react'; 
import { useSelector, useDispatch } from 'react-redux';
import { translatePage } from '../../../../../utils/services/translate';
import { setSelectedPaymentOption } from '../../../../../redux/actions';
import './styles.scss';

// Images
import swishAltImg from '../../../../../assets/icons/payment/Swish_Logo_Primary.svg';
import cardAltImg from '../../../../../assets/icons/payment/Nobina_payment_card 1.svg';
import applepayAltImg from '../../../../../assets/icons/payment/applepay.svg';
import vippsAltImg from '../../../../../assets/icons/payment/vipps.svg';

const PaymentOptions = () => {
  const dispatch = useDispatch();
  const translations = useSelector(state => state.Layout.translations);
  const language = useSelector(state => state.Layout.language);
  const selectedOption = useSelector(state => state.Payment.selected_payment_option);
  const project = useSelector(state => state.Project.project);

  const options = {
    swish: "swish",
    visa: "card",
    mastercard: "card",
    applepay: "applepay",
    vipps: "vipps",
    wallet: "wallet",
  };

  let availableOptions = null;
  if (project !== null) {
  // get first payment method from project and map it directly
    const firstPaymentMethod = project.paymentOptions[0];  
    const firstMappedOption = options[firstPaymentMethod];

    availableOptions = Object.keys(options).reduce((acc, key) => {
      const option = options[key];
      if (project.paymentOptions.includes(key) && !acc.includes(option)) {
        acc.push(option);
      }
      return acc;
    }, []);
    
    // set first payment method as selected
    if (availableOptions.length && !selectedOption) {
      if (availableOptions.includes('vipps')) {
        dispatch(setSelectedPaymentOption('vipps'));
      } else {
        dispatch(setSelectedPaymentOption(firstMappedOption));
      }
    }
  }


  if (!availableOptions?.length) return null;

  // if vipps is available, show only vipps
  if (availableOptions.includes('vipps')) {
    return (
      <div className="row">
      <div className="col-12">
        <div className="payment-methods-placeholder d-flex align-items-center p-2">
        <div className="paymentIcon"></div>
        <div className="paymentIcon"></div>
        <div className="paymentIcon"></div>
        </div>
      </div>
    </div>

    );
  }

  const getPaymentOptionDetails = (option) => {
    let image, text;
    
    switch(option) {
      case 'swish':
        image = swishAltImg;
        text = 'Swish';
        break;
      case 'card':
        image = cardAltImg;
        text = language === 'sv-SE' ? 'Kortbetalning' 
             : language === 'en-US' ? 'Card payment'
             : language === 'fi-FI' ? 'Korttimaksu'
             : language === 'nb-NO' ? 'Kortbetaling'
             : 'Card payment';
        break;
      case 'applepay':
        image = applepayAltImg;
        text = 'Apple Pay';
        break;
      case 'vipps':
        image = vippsAltImg;
        text = 'Vipps';
        break;
      default:
        image = cardAltImg;
        text = option;
    }

    return { image, text };
  };

  const handleOptionClick = (option) => {
    dispatch(setSelectedPaymentOption(option));
  };

  if (availableOptions.length <= 1) return null;

  return (
    <>
      <div className="row">
        <div className="col-12 bg-light p-2 text-center mb-3 rounded text-extra-bold">
          <h4>
            {translatePage(
              translations,
              language,
              "paymentSelectionPage",
              "selectPaymentMethod"
            )}
          </h4>
        </div>
      </div>

      <div className="row">
        {availableOptions.map(option => {
          const { image, text } = getPaymentOptionDetails(option);
          return (
            <div key={option} className="col-12">
              <div
                className={`image-container d-flex align-items-center p-2 box-option ${
                  selectedOption === option ? 'selected' : 'grayed-out'
                }`}
                onClick={() => handleOptionClick(option)}
              >
                <img
                  src={image}
                  alt={`${option} payment`}
                  className="paymentIcon"
                />
                <p className="mt-2 text-extra-bold paymentText">
                  {text}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default PaymentOptions;